// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"703":"8e8eaaa999c24f82","9569":"9a0e5d326342df78"}[chunkId] + ".css";
};